import React from 'react';
import { useTranslation } from 'react-i18next';
import { VscSettings } from 'react-icons/vsc';
import { IdType } from 'react-table';
import MIcon from 'views/MIcon/MIcon';
import { RowData } from 'views/MTable/Table.model';
import classes from './MQuickFiltersButton.module.scss';
import classNames from 'classnames';
import { MQuickFiltersListPosition } from './MQuickFiltersButton.model';
import MSpinner from 'views/MSpinner/MSpinner';

type Props<T extends RowData> = {
  loading?: boolean;
  filtersJSX?: { id: IdType<T>; jsxFunc: () => React.ReactNode }[] | null;
  dropdownRef: React.RefObject<HTMLDivElement>;
  btnFilterState: boolean;
  className?: string;
  position?: MQuickFiltersListPosition;
  onClickBtnFilter: () => void;
};
const MQuickFiltersButtonView = <T extends RowData>(props: React.PropsWithChildren<Props<T>>): JSX.Element => {
  const { t } = useTranslation();

  return (
    <div className={classNames(props.className, classes['container'])}>
      <div className={classes['btnFilters']} onClick={props.onClickBtnFilter}>
        <span>{t('filters.btnFilters')}</span>
        {props.loading ? (
          <div className={classes['spinner']}>
            <MSpinner size="sm" />
          </div>
        ) : (
          <MIcon
            name={VscSettings}
            className={classNames(classes['btnFilters__icon'], { [classes['btnFilters__icon--rotate']]: props.btnFilterState })}
          ></MIcon>
        )}
      </div>

      {props.filtersJSX?.length ? (
        <div
          ref={props.dropdownRef}
          className={classNames(
            classes['filters'],
            { [classes['filters--show']]: props.btnFilterState },
            { [classes[`filters--${props.position}`]]: !!props.position },
          )}
        >
          <span className={classes['filters__title']}>{t('filters.titleDropdown')}</span>
          <div className={classes['filters__content']}>
            {props.filtersJSX?.map((filter: { id: IdType<T>; jsxFunc: () => React.ReactNode }) => {
              return filter.jsxFunc();
            })}
          </div>
        </div>
      ) : null}
    </div>
  );
};

MQuickFiltersButtonView.displayName = 'MQuickFiltersButtonView';

export default MQuickFiltersButtonView;
